/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */

 import axios from '@/axios.js'
import store from "@/store/store";

export default {
  addUser({ commit }, user) {
    // const uuid4 = require('uuid4');
    // this.setDataValue('verifyToken', uuid4());
    // user.verifyToken = uuid4();
    return new Promise((resolve, reject) => {
      store
        .dispatch("users/create", user)
        .then(res => {
          // console.log("state coach created", res)
          // console.log("new state add item", store.state.userManagement.users);
          resolve(res)
        })
        .catch(err => {
          console.log("user create failed", err);
          reject(err);
        });
    });
  },
  resetPassword(context, user){
    return new Promise((resolve, reject) => {
      /*axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })*/
      // user.data.resetToken="";
      store
        .dispatch("users/patch", [user.id, user])
        .then(res => {
          // commit('SET_USERS', res.data)
          resolve(res);
        })
        .catch(err => {
          console.log("user could not be found", err);
          reject(err);
        });
    });
  },
  EmailExist({ commit }, params) {
    return new Promise((resolve, reject) => {
      /*axios.get('/api/user-management/users')
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })*/

      /*const coach = new models.api.Coach({
        email: this.user_email,
        status: "mail_sent",
        email_verified: 0,
        password: null,
        username: null
      })*/

      console.log("Fetching users", params);

      store
        .dispatch("users/find", {query: {email: params.email}})
        .then(res => {
          const id= res.data[0]['id'];
          const token=Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);;
       //   res.data[0]['resetToken']=resetToken;
          const resetTokenData={
            resetToken:token,
            flag:params.flag,
            resetExpires:null
          }
          store
            .dispatch("users/patch", [id,resetTokenData])
            .then(res => {
              //console.log("user data", res.data[0]['id'])
              })
            .catch(err => {
              console.log("users could not be found", err);
              reject(err);
            });
          for(const u in res.data){
            if(res.data[u]['company'][0] !== undefined) {
              res.data[u]["companyName"] = res.data[u]['company'][0]['name']
            }
          }

          commit("SET_USERS", res.data);
          resolve(res);
        })
        .catch(err => {
          console.log("users could not be found", err);
          reject(err);
        });
    });
  },
  fetchUsers({ commit }, params) {
    return new Promise((resolve, reject) => {
      /*axios.get('/api/user-management/users')
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })*/

      /*const coach = new models.api.Coach({
        email: this.user_email,
        status: "mail_sent",
        email_verified: 0,
        password: null,
        username: null
      })*/

      console.log("Fetching users", params);

      store
        .dispatch("users/find", params)
        .then(res => {
          for(const u in res.data){
            if(res.data[u]['company'][0] !== undefined) {
              res.data[u]["companyName"] = res.data[u]['company'][0]['name']
            }
          }
          commit("SET_USERS", res.data);
          resolve(res);
        })
        .catch(err => {
          console.log("users could not be found", err);
          reject(err);
        });
    });
  },
  fetchUser(context, usersId) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("users/get", usersId)
        .then(res => {
          // 1. Check if the user actually has a companyId before fetching
          if (res && res.companyId) {
            store.dispatch("company/get", res.companyId).then(resCompany => {
              console.log("users -> company found", resCompany);
              // const themeColor = resCompany.themeColor; // Unused variable
              resolve(res)
            }).catch(errCompany => {
              console.log("could not find company", errCompany)
              resolve(res)
            })
          } else {
            // 2. If no companyId exists, just resolve the user data immediately
            console.log("User has no companyId assigned.");
            resolve(res); 
          }
        })
        .catch(err => {
          console.log("user could not be found", err);
          reject(err);
        });
    });
  },
  updateUser(context, user) {
    return new Promise((resolve, reject) => {
      /*axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })*/

      store
        .dispatch("users/patch", [user.id, user])
        .then(res => {
          // commit('SET_USERS', res.data)
          resolve(res);
        })
        .catch(err => {
          console.log("user could not be found", err);
          reject(err);
        });
    });
  },
  removeRecord({ commit }, dataObj) {
    return new Promise((resolve, reject) => {
      /*axios.delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })*/

      store
        .dispatch("users/patch", [dataObj.id, dataObj])
        .then(res => {
          commit("REMOVE_RECORD", dataObj.id);
          resolve(res);
        })
        .catch(err => {
          console.log("The selected coach could not be deleted", err);
          reject(err);
        });
    });
  },
  checkExistence ({ commit },query) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("users/find",query)
        .then(res => {
          commit("SET_RESULT", res.data);
          resolve(res);
        })
        .catch(err => {
          console.log("can not be found", err);
          reject(err);
        });
    });
  },
   async gbDataFetch({ commit }, user){
      const gbdata=await axios.get('https://api.getboarded.tech/users?email='+user.email, {
      headers: {
        'Authorization':'Bearer ' + user.accessToken
      }
    });
  return gbdata;
  }
};
